/* Display the saved card estimate. This never chooses a card or changes a purchase. */
(() => {
  const name = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\bpokemon\b/g,'').replace(/\s+/g,' ').trim();
  const match = (container, pack) => [...container.querySelectorAll('[data-account-opening]')].find(template => name(template.dataset.packTitle) === name(pack.title));
  function connect(container, scene, card, template) {
    // Saved order artwork uses the fallback scene, so carry the pack palette
    // across from its matching product template before the opening starts.
    const candidate = template?.dataset.packTier || scene.dataset.packTier;
    const tier = ['gold', 'silver', 'bronze'].includes(candidate) ? candidate : 'gold';
    scene.dataset.packTier = tier;
    const panel = container.querySelector('[data-reveal-value]');
    if (!panel) return;
    panel.dataset.packTier = tier;
    const value = card.estimatedValueCents, currency = card.currency;
    const known = Number.isSafeInteger(value) && value > 0 && currency === 'USD';
    const price = Number(template?.dataset.packPrice);
    // Compare only to the clearly identified current list price, never claim a cash profit.
    const highlight = known && template?.dataset.packCurrency === currency && Number.isSafeInteger(price) && price > 0 && value > price;
    scene.dataset.celebration = highlight ? 'highlight' : 'standard';
    panel.dataset.highlight = String(highlight);
    panel.querySelector('[data-reveal-caption]').textContent = highlight ? 'GREAT PULL' : 'YOUR CARD';
    panel.querySelector('[data-reveal-amount]').textContent = known ? new Intl.NumberFormat('en-US',{style:'currency',currency,minimumFractionDigits:value % 100 ? 2 : 0,maximumFractionDigits:2}).format(value / 100) : 'Estimate unavailable';
    panel.querySelector('[data-reveal-note]').textContent = highlight ? 'Above current pack price · Estimates may change.' : known ? 'Estimates may change.' : 'No estimate was saved for this card.';
    panel.dataset.known = String(known);
    const browse = container.querySelector('[data-reveal-browse]');
    const hide = () => { panel.hidden = true; if (browse) browse.hidden = true; };
    hide();
    scene.addEventListener('pack-opening:start', hide);
    scene.addEventListener('pack-opening:error', hide);
    scene.addEventListener('pack-opening:reveal', () => {
      panel.hidden = false;
      if (browse) browse.hidden = false;
      const title = container.querySelector('[data-replay-title]'); if (title) title.textContent = card.name.replace(/\u2014/g, ":");
    });
  }
  window.PiranhaReveal = {match,connect};
})();
